module.exports = __webpack_public_path__ + "static/img/banner1.1821809b.svg";